import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Card, Button, Container, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import DepartmentTopbar from "../pages/SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "../pages/SuperAdmin/components/DepertmentSidebar";
import UpdateAdvertisementModal from "./UpdateAdvertisementModal";

function AdvertisementList() {
  const [advertisements, setAdvertisements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const fetchAdvertisements = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}list-advertisements.php`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Corrected to check for 'status'
      if (response.data.success && Array.isArray(response.data.data)) {
        setAdvertisements(response.data.data);
      } else {
        setAdvertisements([]);
      }
    } catch (error) {
      toast.error("Failed to fetch advertisements.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  const handleEditClick = (ad) => {
    setSelectedAd(ad);
    setShowEditModal(true);
  };

  const handleDeleteClick = (ad) => {
    setSelectedAd(ad);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedAd) return;
    try {
      const response = await axios.post(
        `${API_URL}delete-advertisement.php`,
        { id: selectedAd.id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status) {
        toast.success("Advertisement deleted successfully!");
        fetchAdvertisements(); // Refresh the list
      } else {
        toast.error(response.data.message || "Failed to delete advertisement.");
      }
    } catch (error) {
      toast.error("An error occurred during deletion.");
    } finally {
      setShowDeleteModal(false);
      setSelectedAd(null);
    }
  };

  const columns = [
    {
      name: "Agency Name",
      selector: (row) => row.agency,
      sortable: true,
      grow: 2,
    },
    {
      name: "Location",
      selector: (row) => row.location,
      sortable: true,
      grow: 2,
    },
    { name: "Start Date", selector: (row) => row.start_date, sortable: true },
    { name: "End Date", selector: (row) => row.end_date, sortable: true },
    {
      name: "Amount (₹)",
      selector: (row) => parseFloat(row.amount).toLocaleString(),
      sortable: true,
    },
    { name: "Bill No", selector: (row) => row.bill_no },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex">
          <Button
            variant="warning"
            size="sm"
            className="me-2"
            onClick={() => handleEditClick(row)}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => handleDeleteClick(row)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <DepartmentTopbar />
      <div className="d-flex">
        <DepartmentSidebar />
        <Container fluid className="p-4 bg-light">
          <Card className="shadow-sm">
            <Card.Header
              as="h5"
              className="d-flex justify-content-between align-items-center"
              style={{
                backgroundColor: "#e3f2fd",
                borderBottom: "2px solid #1976d2",
              }}
            >
              <span style={{ color: "#1976d2" }}>All Advertisements</span>
              <Link to="/departmentDashboard/add-advertisement">
                <Button variant="primary" size="sm">
                  Add New Advertisement
                </Button>
              </Link>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={columns}
                data={advertisements}
                progressPending={loading}
                pagination
                responsive
                highlightOnHover
              />
            </Card.Body>
          </Card>
        </Container>
      </div>

      {/* Edit Modal */}
      {selectedAd && (
        <UpdateAdvertisementModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          adId={selectedAd.id}
          onUpdateSuccess={fetchAdvertisements}
        />
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the advertisement from agency "
          <strong>{selectedAd?.agency}</strong>"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdvertisementList;
